const schema = () => ({
  title: 'Default datatable',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [],
    },
  ],
  properties: {},
  required: [],
});

export default schema;
